import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <Header />

      <main className="products-wrapper">
        <div className="container">
          <div className="products-header">
            <div className="products-count">{productData.length} products</div>
             
          </div>

          <div className="product-grid">
            {productData.map((product) => {
              const salePrice = Number(product.price);
              const computedOriginal = product.originalPrice
                ? Number(product.originalPrice)
                : Number((salePrice * 1.2).toFixed(2));
              const showOriginal = computedOriginal > salePrice;
              const discountPercent = showOriginal
                ? Math.round((1 - salePrice / computedOriginal) * 100)
                : 0;

              return (
                <div key={product.id} className="product-card">
                  <Link to={`/shopDetails/${product.id}`} className="product-image-link" onClick={toTop}>
                    <div className="image-wrap">
                      {discountPercent > 0 && <span className="badge">-{discountPercent}%</span>}
                      <img src={product.image} alt={product.name} />
                    </div>
                  </Link>

                  <div className="product-body">
                    <h3 className="product-title">
                      <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                        {product.name}
                      </Link>
                    </h3>

                    <div className="product-price">
                      {showOriginal && <span className="original">${computedOriginal.toFixed(2)}</span>}
                      <span className="sale">${salePrice.toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Shop;


